// src/api/availability.ts
import axios from './axios';
import { DailyAvailability } from '../types/availability';

/**
 * 获取预约可用时间段
 * @param startDate 起始日期（格式：YYYY-MM-DD）
 * @param days 往后获取多少天的数据（默认6天）
 * @returns 可用时间数据数组
 */
export const fetchAvailability = async (
  startDate: string,
  days: number = 6
): Promise<DailyAvailability[]> => {
  const response = await axios.get('/availability', {
    params: {
      start_date: startDate,
      days,
    },
  });

  return response.data;
};
